module.exports = __webpack_public_path__ + "static/img/page_13.74d4e532.png";